// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"TeamsPage_toolbar__1m-JG","add":"TeamsPage_add__P8Cvg","table":"TeamsPage_table__3TA6C"};